module.exports = __webpack_public_path__ + "static/media/illustration.142b0de1.svg";